import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import className from '../../../utils/className';
import styles from './homeSection.css';

const HomeSection = ({ children, title, buttonText, buttonLink, maxWidth }) => {
  return (
    <div {...className(styles.wrapper, maxWidth && styles.maxWidth)}>
      {title && (
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {buttonLink && (
            <NavLink className={styles.buttonLink} to={buttonLink}>
              {buttonText}
            </NavLink>
          )}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

HomeSection.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  maxWidth: PropTypes.bool,
};

export default HomeSection;
